import history from "../../history.js";
import { DEFAULT_LANG } from "../../project-config.js";

import { translations, mapCountryList } from "../index";

const changeUrlwithLanguageChange = (langCode, entryState) => {
  let newUrl = history.location.pathname;

  let logicOf404 =
    newUrl.split("/")[newUrl.split("/").length - 1] !== "" &&
    newUrl.split("/")[newUrl.split("/").length - 2] !== ""
      ? true
      : false;

  if (logicOf404 || newUrl.split("/").length < 3) {
    if (history.location.pathname.includes("preview")) {
      if (mapCountryList.some(code => newUrl.includes(`/${code}/`))) {
        mapCountryList
          .filter(code => {
            if (newUrl.includes(`/${code}/`) && code !== DEFAULT_LANG) {
              return true;
            } else {
              return false;
            }
          })
          .map(code => (newUrl = newUrl.replace(`/${code}/`, "/")));
      }
      newUrl = newUrl.replace("preview", `preview/${langCode}`);
    } else {
      if (mapCountryList.some(code => newUrl.includes(`/${code}/`))) {
        mapCountryList
          .filter(code => {
            if (newUrl.includes(`/${code}/`)) {
              return true;
            } else {
              return false;
            }
          })
          .forEach(code => (newUrl = newUrl.replace(`/${code}/`, "/")));
      }
      newUrl = `/${langCode}${newUrl}`;
    }

    console.info("newUrl2", newUrl, DEFAULT_LANG);
    if (newUrl.includes(`/${DEFAULT_LANG}/`)) {
      newUrl = newUrl.replace(`/${DEFAULT_LANG}/`, "/");
    }

    history.push(encodeURI(newUrl));
  } else {
    history.push("/");
  }
};

export default changeUrlwithLanguageChange;
